/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Trailer Icon component.
 */
export const AssetTrailerIcon = (props: IconProps) => {
  // The svg renders smaller on this on so we need to set the default to 40
  const {color, size = IconSize.large, stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d='M25.4834 29.1118C26.7136 29.1118 27.7109 28.176 27.7109 27.0217C27.7109 25.8674 26.7136 24.9316 25.4834 24.9316C24.2531 24.9316 23.2558 25.8674 23.2558 27.0217C23.2558 28.176 24.2531 29.1118 25.4834 29.1118Z'
        fill={iconColor}/>
      <path d='M34.1207 10.0005H5.83838C5.35081 10.0005 4.88321 10.1823 4.53845 10.5058C4.19369 10.8292 4 11.268 4 11.7254V24.4388C4 24.6651 4.04758 24.8892 4.14003 25.0982C4.23248 25.3072 4.36798 25.497 4.53875 25.6568C4.70953 25.8166 4.91224 25.9432 5.13525 26.0294C5.35826 26.1155 5.5972 26.1596 5.83838 26.1589H9.76604L9.81213 26.0388C10.0195 25.4937 10.4015 25.0221 10.9057 24.6887C11.4099 24.3553 12.0117 24.1763 12.6286 24.1763C13.2454 24.1763 13.8472 24.3553 14.3514 24.6887C14.8556 25.0221 15.2376 25.4937 15.445 26.0388L15.4911 26.1589H22.6295L22.6756 26.0388C22.8807 25.4915 23.2618 25.0175 23.7663 24.6821C24.2708 24.3468 24.8738 24.1667 25.4921 24.1667C26.1104 24.1667 26.7134 24.3468 27.2179 24.6821C27.7224 25.0175 28.1035 25.4915 28.3085 26.0388L28.3597 26.1589H35.7579L35.9832 25.9475V13.6089H36V11.7254C36.0008 11.4955 35.9524 11.2677 35.8577 11.0556C35.763 10.8434 35.6239 10.6513 35.4487 10.4905C35.2735 10.3297 35.0657 10.2034 34.8376 10.1193C34.6095 10.0351 34.3657 9.99476 34.1207 10.0005Z'
        fill={iconColor}/>
      <path d='M12.6293 29.1118C13.8595 29.1118 14.8568 28.176 14.8568 27.0217C14.8568 25.8674 13.8595 24.9316 12.6293 24.9316C11.399 24.9316 10.4017 25.8674 10.4017 27.0217C10.4017 28.176 11.399 29.1118 12.6293 29.1118Z'
        fill={iconColor}/>
    </svg>
  );
};
AssetTrailerIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
